import { api, tagTypes } from "./api";

type PaginationParams = {
  page?: number;
  limit?: number;
  search?: string;
};
export const adminApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllAdmins: builder.query<any, PaginationParams>({
      query: ({ page = 1, limit = 10, search = "" }) => ({
        url: "admin/v1/",
        params: { page, limit, search },
        method: "GET",
      }),
      providesTags: [tagTypes.Admin],
    }),
    getAdmin: builder.query<any, string>({
      query: (adminId) => ({ url: `admin/v1/${adminId}`, method: "GET" }),
      providesTags: [tagTypes.Admin],
    }),
    getActivityLogs: builder.query<any, void>({
      query: () => ({ url: `/admin/v1/activity-logs`, method: "GET" }),
      providesTags: [tagTypes.Admin],
    }),
    addAdmin: builder.mutation<any, any>({
      query: (data) => ({ url: `admin/v1/`, method: "POST", body: data }),
      invalidatesTags: [tagTypes.Admin],
    }),
    editAdmin: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `admin/v1/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [tagTypes.Admin],
    }),
    deleteAdmin: builder.mutation<any, string>({
      query: (id) => ({ url: `admin/v1/${id}`, method: "DELETE" }),
      invalidatesTags: [tagTypes.Admin],
    }),
    sendMail: builder.mutation<any, any>({
      query: (data) => ({
        url: `admin/v1/notification/mail`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.Notification],
    }),
    pushNotification: builder.mutation<any, any>({
      query: (data) => ({
        url: `admin/v1/notification/pn`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.Notification],
    }),
    uploadImage: builder.mutation<any, FormData>({
      query: (data) => ({
        url: `admin/v1/notification/upload-image`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagTypes.Notification],
    }),
    suspendAdmin: builder.mutation<any, { adminId: string; action: string }>({
      query: ({ adminId, action }) => ({
        url: `admin/v1/${adminId}/${action}`,
        method: "PUT",
      }),
      invalidatesTags: [tagTypes.Admin],
    }),
    // Ads endpoints
    createAds: builder.mutation<any, FormData>({
      query: (body) => ({ url: `admin/v1/ads/create`, method: "POST", body }),
      invalidatesTags: [tagTypes.Ad],
    }),
    getAllAds: builder.query<any, { page: number; adType: string }>({
      query: ({ page, adType }) => ({
        url: `admin/v1/ads/data?page=${page}&adType=${adType}`,
        method: "GET",
      }),
      providesTags: [tagTypes.Ad],
    }),
    exportAds: builder.query<any, string | void>({
      query: (adType = "") => ({
        url: `admin/v1/ads/export?adType=${adType}`,
        method: "GET",
      }),
      providesTags: [tagTypes.Ad],
    }),

    // =========================
    // 🔥 FILTER OPTIONS (YOUR NEW ONE)
    // =========================
    filterOptions: builder.query<any, string>({
      query: (user) => ({
        url: `${user}/v1/profile/filter_options`,
        method: "GET",
      }),

      // 🔥 THIS MAKES YOUR COMPONENT CLEAN
      transformResponse: (response: any) => {
        return response?.payload?.data || {};
      },

      providesTags: ["FilterOptions"],
    }),

    toggleSuspendAd: builder.mutation<any, string>({
      query: (id) => ({
        url: `admin/v1/ads/toggle-suspend-status/one?ad_id=${id}`,
        method: "PUT",
        body: { ad_id: id },
      }),
      invalidatesTags: [tagTypes.Ad],
    }),
    deleteAd: builder.mutation<any, string>({
      query: (id) => ({
        url: `admin/v1/ads/soft-delete/one?ad_id=${id}`,
        method: "PUT",
      }),
      invalidatesTags: [tagTypes.Ad],
    }),
    updateAds: builder.mutation<any, FormData>({
      query: (body) => ({ url: `admin/v1/ads/update`, method: "POST", body }),
      invalidatesTags: [tagTypes.Ad],
    }),
    getSingleAds: builder.query<any, string>({
      query: (id) => ({
        url: `admin/v1/ads/data-id?ad_id=${id}`,
        method: "GET",
      }),
      providesTags: [tagTypes.Ad],
    }),
    exportReferral: builder.query<any, void>({
      query: () => ({
        url: `admin/v1/export/referral/leaderboard`,
        method: "GET",
      }),
      providesTags: [tagTypes.Referral],
    }),
  }),
});

export const {
  useGetAllAdminsQuery,
  useGetAdminQuery,
  useGetActivityLogsQuery,
  useAddAdminMutation,
  useEditAdminMutation,
  useDeleteAdminMutation,
  useSendMailMutation,
  usePushNotificationMutation,
  useUploadImageMutation,
  useSuspendAdminMutation,
  useCreateAdsMutation,
  useGetAllAdsQuery,
  useExportAdsQuery,
  useLazyExportAdsQuery,
  useFilterOptionsQuery,
  useToggleSuspendAdMutation,
  useDeleteAdMutation,
  useUpdateAdsMutation,
  useGetSingleAdsQuery,
  useExportReferralQuery,
  useLazyExportReferralQuery,
} = adminApi;
